export default __webpack_public_path__ + "static/media/blank-tablet.01b010c7.svg";